/**
 * 获取url中 #后面的hash值?后面的参数，并转换为key value的对象值
 * @param {String} url 
 * @returns {Object} 
 */
export const getQuery = function(url) {
  let query = {}
  if (url.indexOf('#') > 0) {
    let ar = url.split('#')
    if (ar[1].indexOf('?') >= 0) {
      let ar2 = ar[1].split('?')
      if (ar2[1].length) {
        let temp = ar2[1].split('&')
        for (let i = 0; i < temp.length; i++) {
          let qar = temp[i].split('=')
          if (qar.length === 2) {
            query[qar[0]] = qar[1]
          }else{
            query[qar[0]] = null
          }
        }
      }
    }
  }
  return query
}

/**
 * 获取url中 ?后面的search值，并转换为key value的对象值
 * @param {String} url
 * @returns {Object}
 */
export const getSearch = function (url) {
  let search = {}
  if (url.indexOf('#') > 0) {
    url = url.split('#')[0]
  }
  if (url.indexOf('?') > 0){
    let ar2 = url.split('?')
    if (ar2[1].length) {
      let temp = ar2[1].split('&')
      for (let i = 0; i < temp.length; i++) {
        let qar = temp[i].split('=')
        if (qar.length === 2) {
          search[qar[0]] = qar[1]
        }else{
          search[qar[0]] = null
        }
      }
    }
  }
  return search
}

 
export default {getQuery}
